<template>
    <SelectionButtonsField
        :name="name"
        :items="consultationMethods"
        item-text="name"
        item-value="key"
        :label="label"
        :column-count="2"
        :column-count-md="2"
        :mandatory="mandatory"
    ></SelectionButtonsField>
</template>

<script lang="ts" setup>
import { SelectionButtonsField } from '@/modules/core/components';
import { useCommonDataStore } from '@/modules/proportal/store';
import { storeToRefs } from 'pinia';

defineProps({
    name: { type: String, required: true },
    label: String,
    mandatory: Boolean
})

const { consultationMethods } = storeToRefs(useCommonDataStore())
</script>